import ColumnSet from '@/components/grid/columns/column-set';
import store from '@/store/index';

export default deleteItemHandler => new ColumnSet({
    id: 'lists',
    version: 6,
    store,
    defaultColumns: [
        {
            name: 'id',
            type: 'link',
            to: ({fields}) => ({
                name: 'edit-list-item',
                params: {id: fields.id},
            }),
            sortable: true,
            sticky: true,
        },
        {
            name: 'description',
        },
        {
            name: 'version',
            type: 'link',
            to: ({fields}) => ({
                name: 'history-list-item',
                params: {id: fields.id, version: fields.version},
            }),
            sortable: true,
        },
        {
            name: 'createdTime',
            header: 'Creation Time',
            type: 'datetime',
            sortable: true,
        },
    ],
    otherColumns: [
        {
            name: 'updatedTime',
            header: 'Last Update Time',
            type: 'datetime',
            sortable: true,
        },
    ],
    lockedColumns: [
        {
            header: false,
            type: 'button',
            style: {
                preset: 'delete',
                tooltip: 'delete',
            },
            click: ({rowData, grid}) => {
                deleteItemHandler(rowData, grid);
            },
        },
    ],
});
